<div class="upload-file--wrapper" [formGroup]="formGroup" *ngIf="field">
  <nx-file-uploader
    [formControlName]="field.name"
    [required]="field.required || false"
    #documentUpload
    [accept]="field.filePermitted || ''"
    [multiple]="field.multiple || false"
    [maxFileSize]="field.fileMaxSize"
    [itemTemplate]="customItemTemplate"
    (fileDeleted)="onDeleteFile($event)"
    (filesSelected)="onSelectedFile($event)"
  >
    <nx-label size="small" class="nx-margin-bottom-xs">
      {{ field.label | translate }}
      <span *ngIf="field.required">*</span>
      <app-popover-form
        class="nx-margin-left-2xs popover-item"
        *ngIf="field.popover"
        [popover]="field.popover"
        (popoverShow)="onPopoverShow($event)"
      ></app-popover-form>
    </nx-label>

    <span
      *ngIf="field?.typeLabel"
      class="nx-margin-bottom-s"
      nxFileUploadHint
      [innerHtml]="field.typeLabel ?? '' | translate"
    ></span>

    <nx-file-uploader-drop-zone
      class="nx-margin-bottom-m nx-margin-top-2xs"
      *ngIf="field?.draggable; else addButton"
      (fileDropped)="onDropped($event)"
    >
      <span nxCopytext class="nx-margin-right-2xs nx-hidden-xs nx-hidden-s" *ngIf="field.dragText">
        {{ field.dragText | translate }}
      </span>
      <ng-container *ngTemplateOutlet="addButton"></ng-container>
    </nx-file-uploader-drop-zone>

    <ng-template #addButton>
      <button
        [nxButton]="field.uploadButton.nxButton || 'secondary small'"
        type="button"
        nxFileUploadButton
      >
        <nx-icon
          *ngIf="field.uploadButton.showButtonIcon"
          name="plus"
          class="nx-margin-right-2xs"
        ></nx-icon>
        {{ field.uploadButton.label | translate }}
      </button>
    </ng-template>
    <nx-error
      nxFormfieldError
      *ngFor="
        let item of (!field.hideErrorBox && formGroup.controls[field.name]?.errors) || {}
          | errorArrayKeys
      "
    >
      <div class="error-container">
        {{
          (field.customErrorLabel && field.customErrorLabel[item]
            ? field.customErrorLabel[item]
            : 'azForm.errors.' + item
          ) | translate
        }}
      </div>
    </nx-error>
  </nx-file-uploader>
</div>
<ng-template #customItemTemplate let-templateContext="templateContext" let-file="file">
  <div class="upload-file--name">
    <dynamic-component
      [component]="{
        component: field.options?.uploadNameComponent ?? fileDataManager['uploadNameComponent'],
        data: {file: file},
      }"
    ></dynamic-component>
  </div>

  <div class="upload-file--size">
    <dynamic-component
      [component]="{
        component: field.options?.uploadSizeComponent ?? fileDataManager['uploadSizeComponent'],
        data: {file: file, field: field, templateContext: templateContext},
      }"
    ></dynamic-component>
  </div>

  <div class="nx-file-uploader--file-row-actions">
    <div class="upload-file--status">
      <dynamic-component
        [component]="{
          component:
            field.options?.uploadStatusComponent ?? fileDataManager['uploadStatusComponent'],
          data: {file: file, field: field, templateContext: templateContext},
        }"
      ></dynamic-component>
    </div>

    <div class="upload-file--delete">
      <dynamic-component
        [component]="{
          component:
            field.options?.uploadDeleteComponent ?? fileDataManager['uploadDeleteComponent'],
          data: {file: file, field: field, templateContext: templateContext},
        }"
      ></dynamic-component>
    </div>
  </div>
</ng-template>
